import { render } from "./Map.html?vue&type=template&id=821bb4b0"
import script from "./Map.vue?vue&type=script&lang=js"
export * from "./Map.vue?vue&type=script&lang=js"

import "./Map.vue?vue&type=style&index=0&id=821bb4b0&lang=scss"

import exportComponent from "/builds/X-G46iqx/0/agitprop/vue-components/pre-election-2021-map/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__